import { render, staticRenderFns } from "./knowledge_detail.vue?vue&type=template&id=18003dfa&scoped=true"
import script from "./knowledge_detail.vue?vue&type=script&lang=js"
export * from "./knowledge_detail.vue?vue&type=script&lang=js"
import style0 from "./knowledge_detail.vue?vue&type=style&index=0&id=18003dfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18003dfa",
  null
  
)

export default component.exports